<template>
    <div class="footer-container">
      <div class="images">
        <img :src="footerWebsite" class="lazyload" alt="Footer image of wing of a plane" />
        <img :src="golf" class="lazyload" alt="Golf" />
        <div class="gradient"></div>
      </div>
      <div class="col">
        <div class="footer-information">
          <div class="col">
            <template v-for="menu in getFooterMenuInfo">
              <router-link :to="menu.slug" exact style="color: #fff;" v-bind:key="menu.title">
                {{ menu.title }}<br />
              </router-link>
            </template>
          </div>
          <div class="col">
            <template v-if="validFooter">
              <span>{{ siteName }}</span><br />
              <span v-html="siteAddress"></span>
            </template>
            <br /><br />
          </div>
          <div class="col" v-if="validFooter">
            <span class="info-letter">E</span> <a style="color: #fff;" :href="'mailto:' + siteEmail">{{ siteEmail }}</a><br />
            <span class="info-letter">T</span> <a style="color: #fff;" :href="'tel:' + sitePhoneLink">{{ sitePhone }}</a><br />
          </div>
          <div class="col">
            &copy; {{ year }} <span v-if="validFooter">{{ siteName }}</span>
            <span v-if="!homepage"><br /><br />
              <a v-if="hasLinkedInUrl" :href="linkedInUrl" title="LinkedIn" target="_blank">
                <font-awesome-icon :icon="['fab', 'linkedin']" class="icon-styling-small btn-zoom-noshadow"></font-awesome-icon>
              </a>
              <a v-if="hasFacebookUrl" :href="facebookUrl" title="Facebook" target="_blank">
                <font-awesome-icon :icon="['fab', 'facebook']" class="icon-styling-small btn-zoom-noshadow"></font-awesome-icon>
              </a>
              <a v-if="hasInstagramUrl" :href="instagramUrl" title="Instagram" target="_blank">
                <font-awesome-icon :icon="['fab', 'instagram']" class="icon-styling-small btn-zoom-noshadow"></font-awesome-icon>
              </a>
              <a v-if="hasYoutubeUrl" :href="youtubeUrl" title="Youtube" target="_blank">
                <font-awesome-icon :icon="['fab', 'youtube']" class="icon-styling-small btn-zoom-noshadow"></font-awesome-icon>
              </a>
              <a v-if="hasTwitterUrl" :href="twitterUrl" title="Twitter" target="_blank">
                <font-awesome-icon :icon="['fab', 'twitter']" class="icon-styling-small btn-zoom-noshadow"></font-awesome-icon>
              </a>
            </span>
          </div>
        </div>
      </div>
      <template v-if="hasQuotesByLanguage && !homepage">
        <div v-for="(quote, index) in getQuotesByLanguage" v-bind:key="index">
          <div class="testimonial-container">
            <div class="testimonial fade">
              <div class="testimonial-text">
                “{{ quote[0].quote }}”
              </div>
              <div class="testimonial-from-whom">
                {{ quote[0].quotePositionAndName }}
              </div>
              <div class="btn testimonial-btn btn-zoom">
                <a :href="quote[0].url" style="color: #fff;">
                  {{ quote[0].buttonText }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="homepage">
        <div class="social-container">
          <h2 v-if="isoCode === 'nl'">Volg ons op social media</h2>
          <h2 v-if="isoCode === 'en'">Follow us on social media</h2>
          <h2 v-if="isoCode === 'de'">Folgen Sie uns auf Social Media</h2>
          <a v-if="hasLinkedInUrl" :href="linkedInUrl" title="LinkedIn" target="_blank">
            <font-awesome-icon :icon="['fab', 'linkedin']" class="icon-styling btn-zoom-noshadow"></font-awesome-icon>
          </a>
          <a v-if="hasFacebookUrl" :href="facebookUrl" title="Facebook" target="_blank">
            <font-awesome-icon :icon="['fab', 'facebook']" class="icon-styling btn-zoom-noshadow"></font-awesome-icon>
          </a>
          <a v-if="hasInstagramUrl" :href="instagramUrl" title="Instagram" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" class="icon-styling btn-zoom-noshadow"></font-awesome-icon>
          </a>
          <a v-if="hasYoutubeUrl" :href="youtubeUrl" title="Youtube" target="_blank">
            <font-awesome-icon :icon="['fab', 'youtube']" class="icon-styling btn-zoom-noshadow"></font-awesome-icon>
          </a>
          <a v-if="hasTwitterUrl" :href="twitterUrl" title="Youtube" target="_blank">
            <font-awesome-icon :icon="['fab', 'twitter']" class="icon-styling btn-zoom-noshadow"></font-awesome-icon>
          </a>
        </div>
      </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin'
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'

library.add(faLinkedin)
library.add(faFacebook)
library.add(faInstagram)
library.add(faYoutube)
library.add(faTwitter)

export default {
  name: 'AIS-Footer',
  computed: {
    ...mapGetters('website', [
      'getQuotesByLanguage',
      'hasQuotesByLanguage',
      'getContactInfo',
      'getFooterMenuInfo',
      'getCurrentLanguage'
    ]),
    ...mapGetters('page', [
      'getPage'
    ]),
    hasLinkedInUrl () {
      if (this.linkedInUrl === null) {
        return false
      }

      return (this.linkedInUrl.length > 0)
    },
    hasFacebookUrl () {
      if (this.facebookUrl === null) {
        return false
      }

      return (this.facebookUrl.length > 0)
    },
    hasInstagramUrl () {
      if (this.instagramUrl === null) {
        return false
      }

      return (this.instagramUrl.length > 0)
    },
    hasYoutubeUrl () {
      if (this.youtubeUrl === null) {
        return false
      }

      return (this.youtubeUrl.length > 0)
    },
    hasTwitterUrl () {
      if (this.twitterUrl === null) {
        return false
      }

      return (this.twitterUrl.length > 0)
    }
  },
  watch: {
    getPage (oldPage, newPage) {
      this.setup()
    }
  },
  methods: {
    showQuotes () {
      if (!this.homepage) {
        this.slides = this.$el.getElementsByClassName('fade')
        for (var i = 0; i < this.slides.length; i++) {
          this.slides[i].style.display = 'none'
        }

        this.slideIndex = this.slideIndex + 1
        if (this.slideIndex > this.slides.length) {
          this.slideIndex = 1
        }

        if (typeof this.slides[this.slideIndex - 1] !== 'undefined') {
          this.slides[this.slideIndex - 1].style.display = 'block'
        }
      }

      setTimeout(this.showQuotes, 20000)
    },
    setup () {
      this.validFooter = false
      this.pageInfo = this.getPage
      if (this.pageInfo === null || typeof this.pageInfo.content === 'undefined') {
        return
      }

      if (this.getCurrentLanguage !== null && typeof this.getCurrentLanguage !== 'undefined') {
        this.isoCode = this.getCurrentLanguage.isoCode
        this.homepage = this.pageInfo.content[this.getCurrentLanguage.isoCode].homepage

        if (typeof this.getCurrentLanguage.instagramLink !== 'undefined') {
          this.instagramUrl = this.getCurrentLanguage.instagramLink
        }

        if (typeof this.getCurrentLanguage.linkedInLink !== 'undefined') {
          this.linkedInUrl = this.getCurrentLanguage.linkedInLink
        }

        if (typeof this.getCurrentLanguage.facebookLink !== 'undefined') {
          this.facebookUrl = this.getCurrentLanguage.facebookLink
        }

        if (typeof this.getCurrentLanguage.youtubeLink !== 'undefined') {
          this.youtubeUrl = this.getCurrentLanguage.youtubeLink
        }

        if (typeof this.getCurrentLanguage.twitterLink !== 'undefined') {
          this.twitterUrl = this.getCurrentLanguage.twitterLink
        }

        if (typeof this.getCurrentLanguage.siteName !== 'undefined' &&
            typeof this.getCurrentLanguage.sitePhone !== 'undefined' &&
            typeof this.getCurrentLanguage.siteEmail !== 'undefined' &&
            typeof this.getCurrentLanguage.siteAddress !== 'undefined') {
          this.siteName = this.getCurrentLanguage.siteName
          this.sitePhone = this.getCurrentLanguage.sitePhone
          this.siteEmail = this.getCurrentLanguage.siteEmail

          if (this.sitePhone !== null) {
            this.sitePhoneLink = this.sitePhone
            this.sitePhoneLink.replace('(0)', '')
          }

          if (this.getCurrentLanguage.siteAddress !== null) {
            this.siteAddress = this.getCurrentLanguage.siteAddress.replace(/(?:\r\n|\r|\n)/g, '<br />')
          }

          this.validFooter = true
        } else {
          // We should have it, so let's try again in a second or so.
          setTimeout(() => this.setup(), 1000)
        }
      }
    }
  },
  mounted () {
    this.setup()
    setTimeout(() => this.showQuotes(), 1000)
  },
  data: function () {
    return {
      slideIndex: 1,
      slides: [],
      year: new Date().getFullYear(),
      homepage: false,
      instagramUrl: '',
      facebookUrl: '',
      linkedInUrl: '',
      youtubeUrl: '',
      twitterUrl: '',
      isoCode: 'nl',
      golf: require('@/assets/golf.png'),
      footerWebsite: require('@/assets/footer-website.jpg'),
      validFooter: false,
      siteAddress: '',
      siteName: '',
      sitePhone: '',
      siteEmail: '',
      sitePhoneLink: ''
    }
  }
}
</script>

<style scoped>
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 20s;
  animation-name: fade;
  animation-duration: 20s;
}

@-webkit-keyframes fade {
  0%   {opacity: .1}
  10%  {opacity: 1}
  90%  {opacity: 1}
  100% {opacity: 0}
}

@keyframes fade {
  0%   {opacity: .1}
  10%  {opacity: 1}
  90%  {opacity: 1}
  100% {opacity: 0}
}

.icon-styling {
  color: #262b55;
  font-size: 40px;
  width: 110px;
  height: 110px;
  padding: 15px;
  margin-right: 45px;
}

.icon-styling-small {
  color: #fff;
  font-size: 12px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.footer-container {
  position: relative;
}

.footer-container .col {
  position: relative;
}

.footer-container .social-container {
  position: absolute;
  z-index: 4;
  width: calc(35%);
  margin-right: 50px;
  text-align: left;
  vertical-align: center;
  top: 70px;
  right: 0;
  color: #262b55;
}

.footer-container .social-container h2 {
  margin-bottom: 10px;
  text-align: left;
}

.btn {
  height: 1rem;
  display: inline-block;
  padding: 10px 15px 22px 15px;
}

a.btn {
  text-decoration: none;
}

.info-letter {
  color: #45a3f0;
  font-weight: bold;
}

.footer-information {
  clear: both;
  display: flex;
  flex: column;
  margin-top: -97px;
  z-index: 4;
  color: #fff;
  flex-wrap: wrap;
  font-size: 13px;
}

.footer-information a {
  text-decoration: none;
}

.footer-information .col:nth-child(1) {
  flex-grow: 1;
  flex-basis: 25%;
  z-index: 4;
  padding: 0px 20px 0px 120px;
  flex-wrap: wrap;
}

.footer-information .col:nth-child(2) {
  flex-grow: 1;
  flex-basis: 25%;
  z-index: 4;
  padding: 0px 10px 0px 10px;
  flex-wrap: wrap;
}

.footer-information .col:nth-child(3) {
  flex-grow: 0;
  flex-basis: 16%;
  z-index: 4;
  padding: 0px 20px 0px 20px;
  flex-wrap: wrap;
}

.footer-information .col:nth-child(4) {
  flex-grow: 1;
  flex-basis: 30%;
  z-index: 4;
  padding: 0px 20px 0px 20px;
  flex-wrap: wrap;
}

.footer-container .col {
  width: 100%;
  height: auto;
  max-height: 394px;
  margin: 0px;
  padding: 0px;
}

.footer-container .images {
  position: relative;
  z-index: 0;
}

.footer-container .images .gradient {
  position: absolute;
  max-width: 1366px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: linear-gradient(180deg, rgba(0,212,255,0) 0%, rgba(38,43,85,1) 90%, rgba(38,43,85,1) 100%);
}

.footer-container .images img:nth-child(1) {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: 0;
}

.footer-container .images img:nth-child(2) {
  position: absolute;
  max-width: 1366px;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 2;
  -moz-transform: scale(-1, -1);
  -o-transform: scale(-1, -1);
  -webkit-transform: scale(-1, -1);
  transform: scale(-1, -1);
}

.footer-container .testimonial-container {
  position: absolute;
  z-index: 4;
  width: calc(40%);
  margin-right: 30px;
  text-align: left;
  vertical-align: center;
  top: 10px;
  right: 0;
  color: #262b55;
}

.footer-container .testimonial-container .testimonial {
  display: none;
}

.footer-container .testimonial-container .testimonial .testimonial-text {
  font-size: 18px;
  font-style: italic;
  font-family: "Roboto", sans-serif
}

.footer-container .testimonial-container .testimonial .testimonial-from-whom {
  font-size: 14px;
  font-family: "Roboto", sans-serif
}

.footer-container .testimonial-container .testimonial .testimonial-btn {
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.call-to-action-btn {
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .footer-container .testimonial-container  {
    display: none;
  }

  .icon-styling {
    color: #262b55;
    font-size: 10px;
    width: 25px;
    height: 25px;
    padding: 0px;
    margin-right: 10px;
    margin-left: 5px;
    z-index: 4;
  }

  .footer-container .social-container  {
    position: absolute;
    z-index: 4;
    width: calc(50%);
    margin-right: 0px;
    text-align: left;
    top: 0px;
    right: 0px;
    color: #262b55;
    display: none;
  }

  .footer-container .social-container h2  {
    font-size: 10px;
    margin-left: 5px;
  }

  .footer-information .col:nth-child(1) {
    flex-basis: 0%;
    padding: 0px 20px 0px 20px;
    display: none;
  }

  .footer-information .col:nth-child(2) {
    flex-basis: 0%;
    padding: 10px 20px 0px 20px;
    display: none;
  }

  .footer-information .col:nth-child(3) {
    flex-basis: 0%;
    padding: 60px 5px 0px 20px;
    display: none;
  }

  .footer-information .col:nth-child(4) {
    flex-basis: 0%;
    padding: 0px 20px 0px 20px;
    display: none;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .footer-container .testimonial-container  {
    display: none;
  }

  .icon-styling {
    color: #262b55;
    font-size: 5px;
    width: 30px;
    height: 40px;
    padding: 0px;
    margin-right: 15px;
    margin-left: 5px;
    z-index: 4;
  }

  .footer-container .social-container  {
    position: absolute;
    z-index: 4;
    width: calc(45%);
    margin-right: 0px;
    text-align: left;
    vertical-align: center;
    top: 20px;
    right: 0px;
    color: #262b55;
  }

  .footer-container .social-container h2  {
    font-size: 20px;
    text-align: left;
  }

  .footer-information .col:nth-child(1) {
    flex-basis: 0%;
    padding: 0px 20px 0px 20px;
    display: none;
  }

  .footer-information .col:nth-child(2) {
    flex-basis: 50%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(3) {
    flex-basis: 50%;
    padding: 40px 20px 0px 20px;
  }

  .footer-information .col:nth-child(4) {
    flex-basis: 0%;
    padding: 0px 20px 0px 20px;
    display: none;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .footer-container .testimonial-container  {
    display: block;
  }

  .footer-container .testimonial-container .testimonial .testimonial-text {
    font-size: 13px;
  }

  .footer-container .testimonial-container .testimonial .testimonial-from-whom {
    font-size: 12px;
    font-family: "Roboto", sans-serif
  }

  .icon-styling {
    color: #262b55;
    font-size: 30px;
    width: 45px;
    height: 45px;
    padding: 5px;
    margin-right: 5px;
  }

  .footer-container .social-container {
    position: absolute;
    z-index: 4;
    width: calc(40%);
    margin-right: 10px;
    text-align: left;
    vertical-align: center;
    top: 20px;
    right: 0;
    color: #262b55;
  }

  .footer-container .social-container h2 {
    margin-bottom: 10px;
    text-align: left;
    margin-left: 10px;
  }

  .footer-information .col:nth-child(1) {
    flex-basis: 30%;
    padding: 0px 20px 0px 20px;
    display: block;
  }

  .footer-information .col:nth-child(2) {
    flex-basis: 36%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(3) {
    flex-basis: 33%;
    padding: 10px 20px 0px 20px;
  }

  .footer-information .col:nth-child(4) {
    flex-basis: 0%;
    padding: 0px 20px 0px 20px;
    display: none;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .footer-container .testimonial-container  {
    display: block;
  }

  .footer-container .testimonial-container .testimonial .testimonial-text {
    font-size: 16px;
  }

  .footer-container .testimonial-container .testimonial .testimonial-from-whom {
    font-size: 14px;
    font-family: "Roboto", sans-serif
  }

  .icon-styling {
    color: #262b55;
    font-size: 40px;
    width: 70px;
    height: 70px;
    padding: 15px;
    margin-right: 5px;
  }

  .footer-container .social-container {
    position: absolute;
    z-index: 4;
    width: calc(45%);
    margin-right: 20px;
    text-align: left;
    vertical-align: center;
    top: 30px;
    right: 0;
    color: #262b55;
  }

  .footer-container .social-container h2 {
    margin-bottom: 10px;
    text-align: left;
    margin-left: 20px;
  }

  .footer-information .col:nth-child(1) {
    flex-basis: 25%;
    padding: 0px 20px 0px 50px;
    display: block;
  }

  .footer-information .col:nth-child(2) {
    flex-basis: 25%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(3) {
    flex-basis: 25%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(4) {
    flex-basis: 25%;
    padding: 0px 20px 0px 20px;
    display: block;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .footer-container .testimonial-container  {
    display: block;
  }

  .footer-container .testimonial-container .testimonial .testimonial-text {
    font-size: 20px;
  }

  .footer-container .testimonial-container .testimonial .testimonial-from-whom {
    font-size: 14px;
    font-family: "Roboto", sans-serif
  }

  .icon-styling {
    color: #262b55;
    font-size: 40px;
    width: 80px;
    height: 80px;
    padding: 15px;
    margin-right: 5px;
  }

  .footer-container .social-container {
    position: absolute;
    z-index: 4;
    width: calc(40%);
    margin-right: 20px;
    text-align: left;
    vertical-align: center;
    top: 70px;
    right: 0;
    color: #262b55;
  }

  .footer-container .social-container h2 {
    margin-bottom: 10px;
    text-align: left;
    padding-left: 15px;
  }

  .footer-information .col:nth-child(1) {
    flex-basis: 30%;
    padding: 0px 20px 0px 150px;
    display: block;
  }

  .footer-information .col:nth-child(2) {
    flex-basis: 20%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(3) {
    flex-basis: 20%;
    padding: 0px 20px 0px 20px;
  }

  .footer-information .col:nth-child(4) {
    flex-basis: 30%;
    padding: 0px 20px 0px 90px;
    display: block;
  }
}
</style>
